theme.SlideShow = (function () {
  function Slider(e) {
    let sliderWrapper = e.querySelector(".hero__slider--activation"),
      slideLoop = e.dataset.slideLoop,
      slideAutoplay = e.dataset.slideAutoplay,
      autoplayDuration = e.dataset.autoplayDuration,
      slideLoopValue = true,
      autoplay = false,
      sliderLayout = e.dataset.layout === "centered" ? true : false,
      slideNavPrev = e.querySelector(".swiper-button-prev"),
      slideNavNext = e.querySelector(".swiper-button-next"),
      sliderPagination = e.querySelector(".swiper-pagination"),
      slideShowSpace = parseInt(e.dataset.slideshow)
        ? parseInt(e.dataset.slideshow)
        : 0,
      sliderPerView = parseInt(e.dataset.slidesperview)
        ? parseInt(e.dataset.slidesperview)
        : 1,
      smallDesktop = parseInt(e.dataset.samlldesktopview)
        ? parseInt(e.dataset.samlldesktopview)
        : 1,
      tabletShow = parseInt(e.dataset.showTablet)
        ? parseInt(e.dataset.showTablet)
        : 1,
      mobileShow = parseInt(e.dataset.showMobile)
        ? parseInt(e.dataset.showMobile)
        : 1;

    if (slideLoop == "false") {
      slideLoopValue = false;
    }
    if (slideAutoplay == "true") {
      let sliderDuration = parseInt(autoplayDuration);
      autoplay = { delay: autoplayDuration, disableOnInteraction: false };
    }

    var swiper = new Swiper(sliderWrapper, {
      slidesPerView: mobileShow,
      autoplay: autoplay,
      loop: slideLoopValue,
      clickable: true,
      speed: 1000,
      spaceBetween: slideShowSpace,
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        nextEl: slideNavNext,
        prevEl: slideNavPrev,
      },
      breakpoints: {
        0: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: sliderLayout ? 1.3 : tabletShow,
          centeredSlides: sliderLayout ? true : false,
          spaceBetween: sliderLayout ? 20 : slideShowSpace,
        },
        992: {
          slidesPerView: sliderLayout ? 1.4 : smallDesktop,
          centeredSlides: sliderLayout ? true : false,
          spaceBetween: sliderLayout ? 20 : slideShowSpace,
        },
        1200: {
          slidesPerView: sliderLayout ? 1.45 : sliderPerView,
          centeredSlides: sliderLayout ? true : false,
          spaceBetween: sliderLayout ? 20 : slideShowSpace,
        },
      },
      on: {
        afterInit: function () {
          fixVideoSlides();
        },
        resize: function () {
          fixVideoSlides();
        },
        slideChange: function () {
          fixVideoSlides();
        },
      },
    });

    function fixVideoSlides() {
      const videoSlides = e.querySelectorAll('.swiper-slide .video__slider--height');
      videoSlides.forEach(media => {
        const slide = media.closest('.swiper-slide');
        if (slide) {
          slide.style.width = '100vw';
          slide.style.maxWidth = '100vw';
        }
      });
    }

    fixVideoSlides();

    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return Slider;
})();
